import { FileViewer, type FileSource } from '@powerportalspro/react-fluent';

// Zip archives are fetched and unzipped in the browser; the viewer renders a
// folder tree of the contents and previews the selected entry on the right.
const source: FileSource = {
  kind: 'url',
  value: '/_content/PowerPortalsPro.Demo.Client.Customizations/demos/archive.zip',
  fileName: 'archive.zip',
};

export function FileViewerZipSample() {
  return <FileViewer source={source} fileName="archive.zip" maxHeight="420px" />;
}
